module.exports = __webpack_public_path__ + "img/bad_griesbach.02998c6.jpg";